import { useEffect, useState } from 'react';

export const AppVersionBadge = () => {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { version } = await res.json();
        setVersion(version);
      } catch (e) {
        // pomijamy
      }
    };

    load();
  }, []);

  if (!version) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '6px',
        right: '8px',
        fontSize: '11px',
        opacity: 0.7,
        background: 'rgba(0,0,0,0.6)',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '6px',
        zIndex: 999999,
        pointerEvents: 'none'
      }}
    >
      Wersja aplikacji: {version}
    </div>
  );
};